import { render, staticRenderFns } from "./HeaderView.vue?vue&type=template&id=a354c9c4&scoped=true"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"
import style0 from "./HeaderView.vue?vue&type=style&index=0&id=a354c9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a354c9c4",
  null
  
)

export default component.exports